export const GET_DEPOSIT = 'app/financial/deposit/GET_DEPOSIT';
export const GET_DEPOSIT_SUCCESS = 'app/financial/deposit/GET_DEPOSIT_SUCCESS';
export const GET_DEPOSIT_ERROR = 'app/financial/deposit/GET_DEPOSIT_ERROR';

export const CLEAR_LOADED_DEPOSIT =
  'app/financial/deposit/CLEAR_LOADED_DEPOSIT';
